const OriginTypes = {
  qbo: 'qbo'
}

const CompanyTypes = {
  NG: 'NG',
  KE: 'KE'
}

const ObjTypes = {
  deposit: 'deposit',
  invoice: 'invoice',
  creditmemo: 'creditmemo',
  payment: 'payment',
  journalentry: 'journalentry',
  purchase: 'purchase',
  account: 'account',
  customer: 'customer',
  bill: 'bill',
  billpayment: 'billpayment',
  vendorcredit: 'vendorcredit',
  purchaseorder: 'purchaseorder',
  transfer: 'transfer',
  vendor: 'vendor',
  term: 'term'
}

const TxnTypes = [
  ObjTypes.deposit,
  ObjTypes.invoice,
  ObjTypes.creditmemo,
  ObjTypes.payment,
  ObjTypes.journalentry,
  ObjTypes.purchase,
  ObjTypes.bill,
  ObjTypes.billpayment,
  ObjTypes.vendorcredit,
  ObjTypes.purchaseorder,
  ObjTypes.transfer
]

// Name-list entities: not transactions, so each gets its own raw table rather
// than a row in fin.raw_qbo_txn keyed by txn_type. idAlias is the key callers
// read the returned id from.
const NameListTypes = {
  [ObjTypes.account]: { table: 'fin.raw_qbo_account', idColumn: 'account_id', idAlias: 'accountId' },
  [ObjTypes.customer]: { table: 'fin.raw_qbo_customer', idColumn: 'customer_id', idAlias: 'customerId' },
  [ObjTypes.vendor]: { table: 'fin.raw_qbo_vendor', idColumn: 'vendor_id', idAlias: 'vendorId' },
  [ObjTypes.term]: { table: 'fin.raw_qbo_term', idColumn: 'term_id', idAlias: 'termId' }
}

// Types landed raw but not yet shaped. Nothing in here reaches a transform.
const RawOnlyTypes = [
  ObjTypes.bill,
  ObjTypes.billpayment,
  ObjTypes.vendorcredit,
  ObjTypes.purchaseorder,
  ObjTypes.transfer,
  ObjTypes.vendor,
  ObjTypes.term
]

module.exports = {
  NameListTypes,
  RawOnlyTypes,
  OriginTypes,
  CompanyTypes,
  ObjTypes,
  TxnTypes
}
